export default "__VITE_ASSET__C0k7f$t3__"